import React, { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _ from "lodash";
import queryString from "query-string";
import BasePage from "../BasePage";

import { Row, Col, Button } from "react-bootstrap";
import { showDataFetchError } from "../../../../actions/generic/fuseAlerts";
import { addToastAction } from "../../../../actions/generic/toastActions";
import { ToastTypes } from "../../modals/FuseToast";
import {
  fetchPermissions,
  updatePermissions,
} from "../../../../webservices/roles/rolesWs";

import FuseCollapsiblePanel from "../../FuseCollapsiblePanel";
import FuseInputBox from "../../inputFields/FuseInputBox";
import DataTable from "react-data-table-component";
import FuseToolbar from "./../../../generic/FuseToolbar";
import DataTableExtensions from "react-data-table-component-extensions";
import { fuseDataTableCustomStyles } from "../../../../scss/generic/fuse-react-data-table-theme";
import OverviewPanelSearchWrapper from "../generic/OverviewPanelSearchWrapper";

class RolesLinkedPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      isLoading: false,
    };
  }
  

  componentDidMount() {
    if (!_.isEmpty(this.props.roleName) && !_.isEmpty(this.props.dataType))
      this.loadPanelData(this.props.roleName, this.props.dataType);
  }

  drawTable = () => {
    if (this.state.data.length == 0 || _.isEmpty(this.props.columns)) {
      return <p>No Data</p>;
    }

    const conditionalRowStyles = [
      {
        when: (row) =>
          !_.isEmpty(this.state.selectedRow) &&
          row.id === this.state.selectedRow.id,
        style: {
          backgroundColor: "#e3f2fd",
        },
      },
    ];

    const minWidthForCol = (type) => {
      const medium = "200px";
      const large = "300px";
      const xlarge = "400px";
      const normal = "170px";
      const small = "100px";
      const xsmall = "50px";
      const action = "20px";

      switch (type.toLowerCase()) {
        case "action":
          return action;
        case "boolean":
          return xsmall;
        case "int64":
          return small;
        case "datetime":
          return normal;
        case "string":
          return xlarge;
        default:
          return normal;
      }
    };

    let columns = this.props.columns.map((col) => {
      return {
        name: col.description,
        selector: col.name,
        sortable: true,
        minWidth: minWidthForCol(col.columnType),
        width: minWidthForCol(col.columnType),
        cell: (row, index, column) => {
          //We dont have id for permission data
          let key = `${row[col.name]}_${col.name}_${index}_${JSON.stringify(
            row
          )}`;
          let id = `${row[col.name]}_${col.name}_${index}_${JSON.stringify(
            row
          )}`; //`${row['id']}_${col.name}`;
          return (
            <FuseInputBox
              key={key}
              id={id}
              name={col.name}
              length={col.length}
              required={!col.nullable}
              type={col.columnType}
              value={row[col.name]}
              editable={this.state.isInEdit || col.updateable}
              dropDownDisplayValues={col.dropDownDisplayValues}
              dropKeyColumn="key"
              dropValueColumn="value"
              dropDownValues={col.dropDownValues}
              showErrors={true}
              onChange={(val) => {
                row[col.name] = val; //We update the field
                row.isEdited = true;

                // let copiedArray = _.cloneDeep(this.state.data); //We copy our array of data
                // copiedArray[index][col.name] = val; //We update the field
                // copiedArray[index].isEdited = true;
                // this.setState({data: copiedArray, isDirty: true}) //We set our state. If our keys are ok, only the relevant entry in table should re-render
              }}
            />
          );
        },
        compact: true,
      };
    });

    return (
      <div className="fuseHeader mt-2">
        <FuseToolbar
          showSave
          showUndo
          onUndoClicked={this.onUndoClicked}
          onSaveClicked={this.onSaveClicked}
          //saveDisabled={!this.state.isDirty}
        />
        <OverviewPanelSearchWrapper
          data={this.state.data}
          columns={columns}
          panelColumns={
            !_.isEmpty(this.state.data[0])
              ? Object.keys(this.state.data[0])
              : []
          }
        >
          {(filteredItems, resetPaginationToggle, subHeaderComponentMemo) => {
            return (
              <DataTable
                title={this.props.title}
                highlightOnHover
                subHeader={this.state.data.length > 0}
                subHeaderComponent={subHeaderComponentMemo}
                columns={columns}
                data={filteredItems}
                dense
                pagination
                noHeader
                responsive
                expandableRowsHideExpander
                conditionalRowStyles={conditionalRowStyles}
                theme="fuseDataTableTheme"
                customStyles={fuseDataTableCustomStyles}
              />
            );
          }}
        </OverviewPanelSearchWrapper>
      </div>
    );
  };

  onUndoClicked = () => {
    let data = _.cloneDeep(this.state.origionalData);
    this.setState({ data: data, isDirty: false });
  };

  onSaveClicked = () => {
    let edited = this.state.data.filter((x) => x.isEdited === true);
    console.log(edited);
    console.log(edited.length !== 0);
    if (edited.length !== 0) {
      this.setState({ isLoading: true });
      updatePermissions(edited)
        .then((response) => {
          if (!_.isEmpty(response.error)) {
            console.log("Error updating data:");
            console.log(JSON.stringify(response.error));
            this.props.showDataFetchError(response.error.message);
            this.setState({ isLoading: false });
            this.props.addToast(ToastTypes.ERROR, "Error updating records");
          } else if (response.data.success === true) {
            this.setState({ isLoading: false });
            if (
              !_.isEmpty(this.props.roleName) &&
              !_.isEmpty(this.props.dataType)
            )
              this.loadPanelData(this.props.roleName, this.props.dataType);
            this.props.addToast(ToastTypes.SUCCESS, "Permissions Updated");
          } else {
            console.log("Error updating data:");
            console.log(JSON.stringify(response.data));
            this.props.showDataFetchError();
            this.setState({ isLoading: false });
            this.props.addToast(ToastTypes.ERROR, "Error updating records");
          }
        })
        .catch(function (error) {
          console.log("exception:" + error);
          this.props.showDataFetchError(error.message);
          this.props.addToast(ToastTypes.ERROR, "Error updating records");
        });
    }
  };

  render() {
    if (this.state.isLoading)
      if (
        _.isEmpty(this.props.roleName) ||
        _.isEmpty(this.props.dataType) ||
        _.isEmpty(this.props.columns)
      )
        return null;

    return (
      <FuseCollapsiblePanel
        isLoading={this.state.isLoading}
        title={this.props.title + ": " + this.props.roleName}
      >
        {this.drawTable()}
        {/* <hr/>
                    {JSON.stringify(this.state.data)} */}
      </FuseCollapsiblePanel>
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.roleName !== prevProps.roleName)
      this.loadPanelData(this.props.roleName, this.props.dataType);
  }

  loadPanelData = (payload, option) => {
    if (_.isEmpty(payload) || _.isEmpty(option)) return;
    this.setState({ isLoading: true });
    fetchPermissions(payload, option)
      .then((response) => {
        if (!_.isEmpty(response.error)) {
          console.log("Error fetching data:");
          console.log(JSON.stringify(response.error));

          this.setState({ isLoading: false });
          this.props.addToast(ToastTypes.ERROR, "Error fetching records");
          this.props.showDataFetchError(response.error.message);
        } else if (response.data.success === true) {
          let data = response.data.result;
          this.setState({
            data: _.cloneDeep(data),
            origionalData: _.cloneDeep(data),
            isDirty: false,
            isLoading: false,
          });
        } else {
          console.log("Error fetching data:");
          console.log(JSON.stringify(response.data));
          this.props.showDataFetchError();
          this.setState({ isLoading: false });
          // this.props.addToast(ToastTypes.ERROR, "Error fetching records");
        }
      })
      .catch(function (error) {
        console.log("exception:" + error);
        this.setState({ isLoading: false });
        this.props.showDataFetchError(error.message);
        // this.props.addToast(ToastTypes.ERROR, "Error fetching records");
      });
  };
}

RolesLinkedPanel.propTypes = {
  // fetchScreenInfo: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  return {
    scopeIsDirty: state.scope.isDirty,
  };
};

export default connect(mapStateToProps, (dispatch, ownProps) => ({
  showDataFetchError: (exception) => dispatch(showDataFetchError(exception)),
  addToast: (type, text) => dispatch(addToastAction(type, text)), //Not including third parameter...let it default
}))(RolesLinkedPanel);
